import { gql } from "@apollo/client";

export const UPSERT_DATA_INPUT = gql`
  mutation UpsertMMMCycleDataInput(
    $id: String
    $has_updated_spend: Boolean!
    $has_updated_adi: Boolean!
    $has_updated_coe: Boolean!
    $cycle_id: String!
  ) {
    upsertCycleDataInput(
      id: $id
      has_updated_spend: $has_updated_spend
      has_updated_adi: $has_updated_adi
      has_updated_coe: $has_updated_coe
      cycle_id: $cycle_id
    ) {
      message
    }
  }
`;
